import * as sup from "superstruct";

import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import { createResponseStruct } from "@/modules/api/utils/jsonApiStructs";
import { userResourceStruct } from "@/modules/auth/api/resources/user/userResourceStruct";
import { groupItemResourceStruct } from "@/modules/groups/api/resources/groupsResourceStruct";

import { subtaskResourceStruct } from "../resources/subtask/subtaskResourceStruct";
import { getTasksListPath } from "../resources/tasks/tasksResourceConsts";
import { tasksResourceStruct } from "../resources/tasks/tasksResourceStructs";

export const getTasksQuery = (
  jsonApi: JsonApiClient,
  {
    userGroupId,
  }: {
    userGroupId: string;
  }
) => {
  return jsonApi.getMany({
    path: getTasksListPath(userGroupId),
    responseStruct: getTasksResponseStruct,
  });
};

const getTasksResponseStruct = createResponseStruct({
  data: tasksResourceStruct,
  included: sup.array(
    sup.union([
      subtaskResourceStruct,
      userResourceStruct,
      groupItemResourceStruct,
    ])
  ),
});

export type GetTasksResponse = sup.Infer<typeof getTasksResponseStruct>;
